import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppUserDefaultStore, loadVatSetting, saveVatSetting } from '../../../stores/appUserDefaultStore';

export const VatToggle: React.FC = () => {
  const { t } = useTranslation();
  const showExVat = useAppUserDefaultStore(s => s.showExVat);
  
  // Load VAT setting on component mount
  useEffect(() => {
    loadVatSetting();
  }, []);
  
  const handleToggle = async () => {
    try {
      await saveVatSetting(!showExVat);
    } catch (error) {
      console.error('Failed to save VAT setting');
    }
  };
  
  return (
    <div className="flex items-center gap-2 bg-muted/10 dark:bg-muted-dark/10 rounded-lg p-1">
      <button
        className={`px-3 py-1 rounded-md text-sm font-medium transition ${
          showExVat
            ? 'bg-white dark:bg-card-dark shadow text-text dark:text-text-dark'
            : 'hover:bg-white/50 dark:hover:bg-card-dark/50 text-muted dark:text-muted-dark'
        }`}
        onClick={handleToggle}
        disabled={showExVat}
      >
        {t('revenueHistory.exclVat')}
      </button>
      <button
        className={`px-3 py-1 rounded-md text-sm font-medium transition ${
          !showExVat
            ? 'bg-white dark:bg-card-dark shadow text-text dark:text-text-dark'
            : 'hover:bg-white/50 dark:hover:bg-card-dark/50 text-muted dark:text-muted-dark'
        }`}
        onClick={handleToggle}
        disabled={!showExVat}
      >
        {t('revenueHistory.inclVat')}
      </button>
    </div>
  );
};

export default VatToggle;